<template>
  <hr class="my-2 border-t border-md" />
</template>
